export enum EurekaVersion {
  FREE = 'free',
  AIR = 'air',
  IP = 'ip',
  PROTECT = 'protect',
  MATERIAL = 'material',
  INSIGHTS = 'insights',
  LS = 'ls',
}

export enum EditionType {
  /**
   * 老
   */
  FREE = 'free',
  PREMIUM = 'premium',

  /**
   * 新
   */
  OVERLIMIT_RECOMMAND = 'overlimit', // 次数用量超限推荐卡片
}

export enum UpgradeUsageType {
  ONBOARDING = 'onboarding',
  TRY_PREMIUM = 'tryPremium',
  TRIAL_END = 'trialEnd',
}

export enum UsageAmountWhere {
  HOME_BANNER = 'home_banner',
  TECH_SEEK = 'tech_seek',
  TECH_RESEARCH = 'technical_research',
  TECH_MIND = 'tech_mind',
  MATERIAL_MIND = 'material_tech_mind',
  TECH_RISK = 'tech_fmea',
  MONITOR = 'monitor',
  EUREKA_AGENT = 'eureka_agent',
  IDEA = 'idea',
  PROJECT = 'project',
  TRIZ = 'triz',
  // NOTE: 以下这些是Life Sciences Agent场景
  LS_CHAT_AGENT = 'ls_chat_agent',
  LS_DOC_AGENT = 'ls_document_agent',
  LS_MARKUSH_DRAFT_AGENT = 'ls_markush_draft_agent',
}

export const AIR_UPGRADE_EVENT_TYPE = 'SS Eureka Upgrade Page';

// 升级所有埋点source_type
export enum BiTrackPoint {
  AIR_ONBOARDING_UPGRADE_CLICK = 'AIR-onboarding-upgrade-click', // onbording场景触发的升级
  AIR_USAGE_UPGRADE_SHOW = 'AIR-usage-upgrade-show', // 免费版使用量超限弹出
  AIR_USAGE_UPGRADE_CLICK = 'AIR-usage-upgrade-click', // 免费版使用量超限触发的升级
  AIR_HEADER_UPGRADE_CLICK = 'AIR-header-upgrade-click', // 试用版侧栏的主动升级
  AIR_BANNER_UPGRADE_CLICK = 'AIR-banner-upgrade-click', // 试用版横幅的主动升级
  AIR_TRIALEND_UPGRADE_CLICK = 'AIR-trialend-upgrade-click', // 试用版到期弹窗触发的升级
  AIR_USERSETTING_UPGRADE_SHOW = 'AIR-usersetting-upgrade-show', // 用户设置版本页面的显示
  AIR_USERSETTING_UPGRADE_CLICK = 'AIR-usersetting-upgrade-click', // 用户设置版本页面的升级
  AIR_UPGRADE_CLUEREPORT_SUBMIT = 'AIR-upgrade-cluereport-submit', // 中国区升级线索提交成功
  AIR_UPGRADE_UNLOCK_FORM_SHOW = 'AIR-upgrade-unlock-form-show', // 升级解锁表单展示
  AIR_UPGRADE_UNLOCK_FORM_SUBMIT = 'AIR-upgrade-unlock-form-submit', // 升级解锁表单提交
}
